import { AppRoutesPaths } from '@/common/constants';
import { AppButton } from '@/ui/buttons';
import { SimpleLockIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--beige-main);
  border-radius: var(--medium-border-radius);
  padding: 70px var(--medium-big-padding) 80px;
  text-align: center;
  gap: 32px;
  min-height: calc(100% - 220px);
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  svg {
    width: 134px;
    height: 134px;
    opacity: 0.4;
  }
`;

const StyledTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--medium-padding);
  max-width: 620px;

  h2 {
    margin: 0;
    font-size: var(--modal-heading-font-size);
    font-weight: 700;
    line-height: 1.5;
  }

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    max-width: 558px;
  }
`;

export const IntegrationsLockPanel: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledPanel>
      <StyledContent>
        <SimpleLockIcon />
        <StyledTextBlock>
          <h2>{t('integrations.freeTrial.locked.title')}</h2>
          <p>{t('integrations.freeTrial.locked.description')}</p>
        </StyledTextBlock>
      </StyledContent>
      <AppButton
        label={t('integrations.freeTrial.locked.bookMeeting')}
        onClick={() => navigate(AppRoutesPaths.HUBSPOT_BOOKING_ROUTE)}
        style={{
          borderRadius: 'var(--default-border-radius)',
          backgroundColor: 'var(--red-dark)',
          borderColor: 'var(--red-dark)',
        }}
      />
    </StyledPanel>
  );
};
